import axios from 'axios';
import interceptors from './AxiosInterceptors';

export default (uri) => {
    const api = axios.create({
        baseURL : process.env.VUE_APP_API_URL + uri,
    });
    api.interceptors.response.use(interceptors.success, interceptors.error);
    return api;
};

